import Vue from 'vue';

// Domain
import {
  CustomerPersonalInformationStateManager,
  CustomerPersonalInformationState,
} from '../../domain/state';
import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';
import State from '@/modules/internet-status/domain/state/state';

@Injectable()
class CustomerPersonalInformationVueStateManager
implements CustomerPersonalInformationStateManager {
  private _state: CustomerPersonalInformationState =
    Vue.observable<CustomerPersonalInformationState>(new CustomerPersonalInformationState());

  private readonly observers: Observer[] = [];

  get state(): CustomerPersonalInformationState {
    return this._state;
  }

  set state(value: CustomerPersonalInformationState) {
    this._state = value;
    this.notifyAll();
  }

  put(state: CustomerPersonalInformationState) {
    type Keys = keyof State;
    Object.entries(state).forEach(([key, value]) => {
      const accessor = key as Keys;

      if (value !== undefined) {
        // eslint-disable-next-line
        // @ts-ignore @typescript-eslint/ban-ts-ignore
        this.state[accessor] = value;
      }
    });
  }

  notifyAll() {
    this.observers.forEach((observer) => observer.notify());
  }

  register(observer: Observer) {
    this.observers.push(observer);
  }
}

export default CustomerPersonalInformationVueStateManager;
